import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AddRemoveUserToSharedGroupService } from './add-remove-user-to-shared-group.service';
import { DialogEmployeeSearch } from 'dg-emp-search-lib';
import { WorklistService } from '../../worklist/worklist.service';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';
import {
  MatSelectionList,
  MatSelectionListChange,
} from '@angular/material/list';

@Component({
  selector: 'app-add-remove-user-to-shared-group',
  templateUrl: './add-remove-user-to-shared-group.component.html',
  styleUrls: ['./add-remove-user-to-shared-group.component.scss'],
})
export class AddRemoveUserToSharedGroupComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<AddRemoveUserToSharedGroupComponent>,
    private addRemoveUserService: AddRemoveUserToSharedGroupService,
    private _worklistService: WorklistService,
    private authenticationService: AuthenticationService
  ) {}

  @ViewChild('addRemoveUserEmpSearch')
  addRemoveUserEmpSearch: DialogEmployeeSearch;

  selectedEmployeesUnitId = [];

  empConfig = {
    multiSelect: true,
    header: 'share_case.addRemoveUser',
    title: 'Employee_Lists',
    subTitle: 'Employee_Lists',
    selectedSubTitle: 'Mapped_Employee_Lists',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 char',
  };
  orgConfig = {
    prntId: '54',
    fetchPrntOrgOnlyFlag: 'false',
    multiselect: true,
    header: 'Reporting Organization',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters',
  };

  configData = null;

  enableRole = true;
  showEmpSearch = false;
  selectedEmployeesList = [];
  finalEmployeeList = [];

  ngOnInit(): void {
    this.configData = {
      empConfig: this.empConfig,
      orgConfig: this.orgConfig,
      showAllEmps: true,
      callBeforeSearchListener: true,
    };
    if (this.addRemoveUserService?.from === 'Share') {
      this.empConfig.header = 'Share_Case';
    }
    this.showEmpSearch = true;
    this.getAllMappedEmpWithGrpIdByGrpId();
  }

  getAllMappedEmpWithGrpIdByGrpId(): void {
    this.addRemoveUserService
      .getMappedEmpListByGrpId(this.addRemoveUserService?.caseData?.docId)
      .subscribe((res) => {
        let loggedinUserUnit = this.authenticationService.loggedInUser
          ?.employeeVO?.allUnitVO;
        res?.data?.unitIds?.forEach((unit) => {
          this.selectedEmployeesUnitId?.push(unit?.wlRoleId);
          let index = loggedinUserUnit?.findIndex(
            (x) => x?.unitId == unit?.wlRoleId
          );
          if (index > -1) {
            unit.isGrpAdmin = 2;
          }
        });
        this.selectedEmployeesList = res?.data?.unitIds;
        this.selectedEmployeesUnitId = [...this.selectedEmployeesUnitId];
        //this.addRemoveUserEmpSearch?.setSelectedEmpList();
      });
  }

  onSubmit(): void {
    let refIds = [];
    refIds.push(this.addRemoveUserService?.caseData?.docId);
    let postData = {
      wlGrpName: '',
      wlGrpShrtName: '',
      wlGrpDesc: '',
      activeFlag: '1',
      isDripFeed: 0,
      emailId: '',
      unitIds: [],
      appArr: null,
      caseId: refIds,
    };

    for (let i = 0; i < this.selectedEmployeesList?.length; i++) {
      let ele = this.selectedEmployeesList[i];
      let index = this.finalEmployeeList?.findIndex(
        (x) =>
          x?.UNIT_ID?.toString()?.trim() === ele?.wlRoleId?.toString()?.trim()
      );
      if (index === -1) {
        postData?.unitIds?.push({
          wlRoleId: ele?.wlRoleId,
          empId: ele?.empId,
          unitId: ele?.wlRoleId,
          activeFlag: 0,
          isGrpAdmin: 0,
          wlGrpRoleMpgPk: ele?.wlGrpRoleMpgPk,
        });
      }
    }

    this.finalEmployeeList?.forEach((ele) => {
      let isGrpAdmin = 0;
      let wlGrpRoleMpgPk = null;
      let index = this.selectedEmployeesList?.findIndex(
        (x) =>
          x?.wlRoleId?.toString()?.trim() === ele?.UNIT_ID?.toString()?.trim()
      );
      if (index > -1) {
        isGrpAdmin = this.selectedEmployeesList[index]?.isGrpAdmin;
        wlGrpRoleMpgPk = this.selectedEmployeesList[index]?.wlGrpRoleMpgPk;
      }
      postData?.unitIds?.push({
        wlRoleId: ele?.UNIT_ID,
        empId: ele?.EMP_ID,
        unitId: ele?.UNIT_ID,
        activeFlag: 1,
        isGrpAdmin: isGrpAdmin,
        wlGrpRoleMpgPk: wlGrpRoleMpgPk,
      });
      if (postData?.wlGrpName?.indexOf(ele?.FULL_NAME) === -1) {
        postData.wlGrpName += ele?.FULL_NAME + ' , ';
      }
    });
    postData.wlGrpName = postData?.wlGrpName
      ?.toString()
      ?.substring(0, postData?.wlGrpName?.toString()?.length - 3);

    postData.wlGrpShrtName = postData.wlGrpName;
    postData.wlGrpDesc = postData.wlGrpName;

    this._worklistService.shareCase(postData).subscribe(() => {
      this.dialogRef.close(true);
    });
  }

  getEmpData(event): void {
    event?.forEach((ele) => {
      ele.activeFlag = 1;
    });
    this.finalEmployeeList = event;
  }

  removeEmp(employee): void {
    let index;
    index = this.getSelectedEmpIndex(employee);
    this.finalEmployeeList[index] = {
      ...this.finalEmployeeList[index],
      activeFlag: 0,
    };

    let empList = [];

    this.finalEmployeeList?.forEach((emp) => {
      if (emp?.activeFlag != 0) {
        empList?.push(emp);
      }
    });
    this.addRemoveUserEmpSearch.showSelectedMultiEmp = [...empList];
    this.addRemoveUserEmpSearch.selectedMultiEmp = [...empList];
    index = -1;
    this.addRemoveUserEmpSearch?.selectedUnitIdList?.forEach((ele) => {});
    index = -1;
    index = this.addRemoveUserEmpSearch?.selectedUnitIdList?.findIndex(
      (x) => x === employee?.EMP_ID
    );
    if (index > -1) {
      this.addRemoveUserEmpSearch?.selectedUnitIdList?.splice(index, 1);
      this.addRemoveUserEmpSearch?.selectedUnitIdList?.join();
      this.addRemoveUserEmpSearch.selectedUnitIdList = [
        ...this.addRemoveUserEmpSearch?.selectedUnitIdList,
      ];
    }
    this.addRemoveUserEmpSearch?.updateShowSelected();
  }

  getSelectedEmpIndex(employee): number {
    return this.finalEmployeeList?.findIndex(
      (x) => x?.EMP_ID === employee?.EMP_ID
    );
  }

  getIsGrpAdminVal(employee): number {
    let index = this.selectedEmployeesList?.findIndex(
      (x) => x?.wlRoleId === employee?.UNIT_ID
    );
    if (index > -1) {
      return this.selectedEmployeesList[index]?.isGrpAdmin;
    } else {
      return 0;
    }
  }

  isSubmitDisable(): boolean {
    if (this.finalEmployeeList?.length === this.selectedEmployeesList?.length) {
      let flag = false;
      for (let i = 0; i < this.finalEmployeeList?.length; i++) {
        let ele = this.finalEmployeeList[i];
        let index = this.selectedEmployeesList?.findIndex(
          (x) =>
            x?.empId?.toString()?.trim() === ele?.EMP_ID?.toString()?.trim()
        );
        if (index === -1) {
          flag = true;
          break;
        }
      }
      if (flag) {
        return false;
      } else {
        return true;
      }
    } else {
      if (this.finalEmployeeList?.length > 0) {
        return false;
      } else {
        return true;
      }
    }
  }
}
